import { FunctionComponent, PropsWithChildren } from 'react'

const TableCellSubText: FunctionComponent<PropsWithChildren> = ({
    children,
}) => {
    return (
        <span
            style={{
                fontSize: '0.75rem',
                opacity: 0.4,
            }}
        >
            {children}
        </span>
    )
}

export default TableCellSubText
